// English texts for filtered catalogues, food notes, "Who is eating?" and menu suggestions (0024).
export const appCultureEn = {
    hidden: {
        groupFaithNone: 'Hidden because you chose No religion',
        searchHidden: 'Hidden options',
    },
    kitchens: {
        filterLabel: 'Cuisine',
        all: 'All cuisines',
    },
    menu: {
        suggestionsTitle: 'Ideas for this week',
        suggestionsHint: 'Tap an idea and pick a day.',
        noSuggestions: 'No more ideas for this week.',
        whoEats: 'Who is eating?',
        everyoneEats: 'Everyone is eating',
        notEating: '{names} is not eating',
        markerLabel: 'Note for this dish: {text}',
        chooseDay: 'Pick a day for {title}',
    },
    warning: {
        title: 'Does this suit everyone?',
        swapped: 'Swapped: {swap} instead of {ingredient}.',
        eatsOtherSaved: 'Noted: {name} eats something else with this dish.',
        added: 'Added.',
    },
    recipes: {
        original: '{name}',
    },
};
//# sourceMappingURL=cultureApp.en.js.map